import AppCalendar from './AppCalendar.vue'
import AppSchedules from './AppSchedules.vue'
import Multiselect from 'vue-multiselect'
import { isMobile, isIOS } from 'mobile-device-detect'

const loadDynamicStyle = (url, libName) => {
  const existingLink = document.getElementById(libName)

  if (!existingLink) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = url
    link.id = libName
    link.media = 'all'
    document.body.appendChild(link)
  }
}

const loadDynamicScript = (url, libName) =>
  new Promise((resolve) => {
    const existingScript = document.getElementById(libName)

    if (!existingScript) {
      const script = document.createElement('script')
      script.defer = true
      script.src = url
      script.id = libName
      document.body.appendChild(script)
      script.onload = () => {
        resolve()
      }
    }
  })

const materialIcons = loadDynamicStyle(
  'https://fonts.googleapis.com/icon?family=Material+Icons+Outlined',
  'materialIcons'
)
const polyfillScript = loadDynamicScript(
  'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js',
  'polyfillScript'
)
const baseUrl = document.querySelector('[id^="spookynook-activenet"]').getAttribute('data-base-url')
const atcScript = loadDynamicScript(baseUrl + '/modules/custom/sns_vue/js/atc.js', 'atcScript')
const axiosScript = loadDynamicScript(
  'https://cdnjs.cloudflare.com/ajax/libs/axios/0.21.1/axios.min.js',
  'axiosScript'
)
const vueScript = loadDynamicScript(
  'https://cdnjs.cloudflare.com/ajax/libs/vue/2.6.14/vue.min.js',
  'vueScript'
)
const vueRouterScript = loadDynamicScript(
  'https://cdnjs.cloudflare.com/ajax/libs/vue-router/3.5.2/vue-router.min.js',
  'vueRouterScript'
)

Promise.all([
  materialIcons,
  polyfillScript,
  axiosScript,
  atcScript,
  vueScript,
  vueRouterScript
]).then(() => {
  const Vue = window.Vue
  const VueRouter = window.VueRouter

  Vue.config.devtools = true
  Vue.config.productionTip = false

  Vue.filter('t', function (value) {
    return value // Drupal translations that doesn't work on Hubspot
  })

  Vue.component('multiselect', Multiselect)

  Vue.use(VueRouter)
  const routes = []
  const router = new VueRouter({
    routes,
    mode: 'history'
  })

  Vue.mixin({
    computed: {
      isIosMobile() {
        let iosMobile = false
        if (isMobile && isIOS) {
          iosMobile = true
        }
        return iosMobile
      }
    },
    methods: {
      t(value) {
        return value // Drupal translations that doesn't work on Hubspot
      }
    }
  })

  if (document.getElementById('spookynook-activenet-calendar-widget')) {
    new Vue({
      router,
      data: {
        baseUrl: null,
        location: null,
        category: null,
        activity: null,
        sport: null,
        organization: null
      },
      beforeMount: function () {
        this.baseUrl = this.$el.attributes['data-base-url']?.value
        this.location = this.$el.attributes['data-location']?.value
        this.category = this.$el.attributes['data-category']?.value
        this.activity = this.$el.attributes['data-activity']?.value
        this.sport = this.$el.attributes['data-sport']?.value
        this.organization = this.$el.attributes['data-organization']?.value
      },
      render: (h) => h(AppCalendar)
    }).$mount('#spookynook-activenet-calendar-widget')
  }

  if (document.getElementById('spookynook-activenet-schedules-widget')) {
    new Vue({
      router,
      data: {
        baseUrl: null,
        organization: null
      },
      beforeMount: function () {
        this.baseUrl = this.$el.attributes['data-base-url']?.value
        this.organization = this.$el.attributes['data-organization']?.value
      },
      render: (h) => h(AppSchedules)
    }).$mount('#spookynook-activenet-schedules-widget')
  }
})
